var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9464 6.05314C10.3941 6.05314 9.94641 5.60543 9.94641 5.05314C9.94641 4.50086 10.3941 4.05314 10.9464 4.05314C11.4987 4.05314 11.9464 4.50086 11.9464 5.05314C11.9464 5.60543 11.4987 6.05314 10.9464 6.05314Z",
    fill: "#E2B912"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55975 1.34648H8.61308L12.6131 1.63314C13.5447 1.71651 14.2831 2.45485 14.3664 3.38648L14.6597 7.38648C14.6966 7.75454 14.5698 8.12019 14.3131 8.38648L8.68641 14.0131C8.44876 14.2421 8.12966 14.3668 7.79975 14.3598C7.29502 14.3554 6.81375 14.146 6.46641 13.7798L2.21975 9.53981C1.56009 8.99293 1.45657 8.0199 1.98641 7.34648L7.64641 1.67981C7.88526 1.45275 8.20356 1.3283 8.53308 1.33314L8.55975 1.34648ZM8.53308 2.41981C8.49402 2.40753 8.45214 2.40753 8.41308 2.41981L2.77975 8.05314C2.72526 8.30301 2.8185 8.56201 3.01975 8.71981L7.27975 12.9798C7.42009 13.1321 7.61321 13.225 7.81975 13.2398H7.93308L13.5464 7.57981C13.5643 7.53257 13.5643 7.48039 13.5464 7.43314L13.2531 3.43314C13.2007 3.07035 12.9209 2.78244 12.5597 2.71981L8.55975 2.43314L8.53308 2.41981Z",
    fill: "#E2B912"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowTag);
export default __webpack_public_path__ + "static/media/yellow-tag.0773b0c6347223cf478163f3ae9b6c50.svg";
export { ForwardRef as ReactComponent };